import axios from "axios";


const apiGrid = (fillVar, ready) => {
    axios.get("https://nyu.danielwalt.io/api/grid")
        .then((resp) => {
            fillVar.value = resp.data;
            ready.value = true;
        })
        .catch((err) => {
            console.log(err);
            fillVar.value = [{}];
            ready.value = false;
        });
}

export {apiGrid}